import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import PayoutRouting from "./PayoutRouting";
import RouteIcon from "@mui/icons-material/Route";
import CustomTip from "../../common/CustomToolTip/CustomTip";
import useApiServices from "../../utils/useApiServices";
import { GET_ALL_SUBMITTED_PAYOUT_ROUTING } from "../../utils/constant";
import useHasPrivilege from "../../Privillages/useHasPrivilege";
import { OnBoardingActionRegistry } from "../../Privillages/ActionRegistry";

const PayoutSubmitted = ({
  showEditButton,
  showEnaDisaButton,
  type,
  toggleRightBar,
}) => {
  const { SECTION_KEY, PAYOUT_EDIT } = OnBoardingActionRegistry;
  const hasPayoutEdit = useHasPrivilege(SECTION_KEY, PAYOUT_EDIT);
  const [applications, setApplications] = useState([]);
  const [isModalRoutingOpen, setIsModalRoutingOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const handleShowRouting = () => setIsModalRoutingOpen(true);

  const columns = [
    { headerName: "Merchant ID", field: "mid", width: 200 },
    { headerName: "Merchant Name", field: "companyName", width: 230 },
    // { label: "SID", field: "sid", width: "auto" },
    { headerName: "Mapped With", field: "mappedWithCompanyName", width: 250 },
    { headerName: "Callback URL", field: "callbackUrl", width: 220 },
    { headerName: "Transfer Type", field: "transferType", width: 200 },
    { headerName: "Access Type", field: "usedFor", width: 200 },
    { headerName: "Route With", field: "requestRoute", width: 200 },
    // { headerName: "Action", field: "action", width: 200 },
  ];
  const { apiCallFnforGet } = useApiServices();

  const handleCloseModalRouting = () => {
    setIsModalRoutingOpen(false);
  };

  const FetchData = async () => {
    // setShowLoader(true);
    try {
      const apiResponse = await apiCallFnforGet(
        GET_ALL_SUBMITTED_PAYOUT_ROUTING
      );
      //   setShowLoader(false);
      if (apiResponse.statusCode === 200) {
        const finalRes = apiResponse.data.map((item, i) => ({
          id: i,
          mid: item.mid,
          companyName: item.companyName,
          mappedWithCompanyName: item.mappedWithCompanyName,
          callbackUrl: item.callbackUrl,
          transferType: item.transferType,
          usedFor: item.usedFor,
          requestRoute: item.requestRoute,
        }));
        setApplications(finalRes);
      } else {
      }
    } catch (error) {
      //   setShowLoader(false);
    }
  };
  useEffect(() => {
    FetchData();
  }, [isModalRoutingOpen, refresh, setRefresh]);

  return (
    <>
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center me-4">
          <div className="d-flex align-items-center">
            <button
              type="button"
              class="btn-close m-3"
              onClick={toggleRightBar}
            ></button>

            <div className="fs-2 text-dark fw-bold">Payout</div>
          </div>
          {hasPayoutEdit && (
            <div className="mt-3">
              <CustomTip size="18" placement="top" title="Routing">
                <div className="" onClick={handleShowRouting}>
                  <RouteIcon fontSize="large" />
                </div>
              </CustomTip>
            </div>
          )}
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="col-12">
                <div className="card-body">
                  <div className="table-responsive">
                    <DataGrid
                      rows={applications}
                      columns={columns.map((column) => ({
                        ...column,
                        renderCell: (params) =>
                          column.field === "active" || column.field === "action"
                            ? params.value
                            : params.value,
                      }))}
                      slots={{
                        toolbar: GridToolbar,
                      }}
                      slotProps={{
                        toolbar: {
                          showQuickFilter: true,
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PayoutRouting
        show={isModalRoutingOpen}
        FetchData={FetchData}
        onHide={handleCloseModalRouting}
        setRefresh={setRefresh}
        refresh={refresh}
      />
    </>
  );
};

export default PayoutSubmitted;
